var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "main-pos" } }, [
    _c(
      "header",
      { ref: "header", staticClass: "common-header" },
      [_vm._t("header")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "main",
        style: [{ "padding-top": _vm.mainOffsetTop + "px" }]
      },
      [_vm._t("content")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48200785", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48200785","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/common/ContentWithHeader.vue
// module id = null
// module chunks = 